import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ImageTagComponent, ButtonComponent, InputComponent } from '../../ui';
import { AdminAuthService } from '../../../services/admin-auth.service';
import { ErrorService } from '../../../shared/services/error.service';
import { API_CONFIG } from '../../../config/api.config';
import { AuthUrls, ApiUrlBuilder } from '../../enums/api-urls/api-urls.enum';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-admin-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ImageTagComponent,
    ButtonComponent,
    InputComponent
  ],
  templateUrl: './admin-forgot-password.component.html',
  styleUrl: './admin-forgot-password.component.css'
})
export class AdminForgotPasswordComponent {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);
  private baseUrl = API_CONFIG.getBaseUrl();

  isLoading = signal(false);
  emailSent = signal(false);
  
  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  get logoUrl(): string {
    return '/assets/images/logo.png';
  }

  get backgroundImageUrl(): string {
    return '/assets/images/login-bg.jpg';
  }

  async onSubmit(): Promise<void> {
    if (this.forgotPasswordForm.valid) {
      this.isLoading.set(true);
      
      try {
        const email = this.forgotPasswordForm.get('email')?.value;
        console.log(email,'email')
        const forgotPasswordUrl = ApiUrlBuilder.buildFullUrl(AuthUrls.FORGOT_PASSWORD, this.baseUrl);
        
        const response = await firstValueFrom(
          this.http.post<any>(forgotPasswordUrl, { loginId: email })
        );

        if (response.success) {
          this.emailSent.set(true);
          this.errorService.showSuccess(response.message || 'Password reset link sent to your email');
        } else {
          this.errorService.showError(response.message || 'Failed to send password reset link');
        }
      } catch (error: any) {
        console.error('Forgot password error:', error);
        this.errorService.showError(error.error?.message || 'Failed to send password reset link. Please try again.');
      } finally {
        this.isLoading.set(false);
      }
    } else {
      Object.keys(this.forgotPasswordForm.controls).forEach(key => {
        this.forgotPasswordForm.get(key)?.markAsTouched();
      });
    }
  }

  goToLogin(): void {
    this.router.navigate(['/admin/login']);
  }
}




